import apiClient from './api.service'

export const InquiryService = {
  getInquiryForms: async (tenantid, language) => {
    try {
      const params = { tenantid }
      if (language) {
        params.language = language
      }
      const response = await apiClient.get('/api/customer-inquiry', {
        params,
      })
      const data = response.data || response
      return data
    } catch (error) {
      console.error('Error fetching inquiry forms:', error)
      throw error
    }
  },

  submitInquiry: async (tenantid, formId, formData, language) => {
    try {
      const payload = {
        tenantid,
        formId,
        formData,
      }
      if (language) {
        payload.language = language
      }
      const response = await apiClient.post('/api/customer-inquiry/submit', payload)
      return response
    } catch (error) {
      console.error('Error submitting inquiry:', error)
      throw error
    }
  },
}

export default InquiryService
